import { navigate } from "gatsby";

export const isBrowser = () => typeof window !== "undefined";

const setTellToken = (data) => {
  window.localStorage.setItem("access-token", data);
};

const getBasePath = () => {
  const url = isBrowser ? window.location.hostname : "";
 
  let basePath = "";
  switch (url) {
    case "platform-dev.tell.money":
    case "aspsp-dev.tell.money":
    //case "localhost":
      // UNAUTHENTICATED USER - ALWAYS LOGOUT
      basePath = "https://system.tell.money/dev/";
      break;
    default:
      // OUTPUT TO BE HANDLED BY APPLICATION
      basePath = "https://system.tell.money/v1/";
  }

  return basePath;
};

const getTellToken = () => {
  if (isBrowser() && window.localStorage.getItem("access-token")) {
    const token = window.localStorage.getItem("access-token");
    return token;
  } else {
    return "";
  }
};

export const api_handler = async (func, data, method) => {
  const basePath = getBasePath();

  let rsp_code = "";
  let rsp_obj = {};

  var construct = {
    function: func,
    request: data,
  };

  try {
    await fetch(basePath + `aspsp/platform`, {
      method: method, // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getTellToken(),
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(construct), // body data type must match "Content-Type" header
    })
      .then((response) => {
        let accesstoken = response.headers.get("x-jwt");
        if (accesstoken !== "") {
          setTellToken(accesstoken);
        }

        rsp_code = response.status;

        return response.json();
      }) // parse JSON from request
      .then((resultData) => {
        switch (rsp_code) {
          case 401:
            // UNAUTHENTICATED USER - ALWAYS LOGOUT
            navigate("/restricted/");
            break;
      
          default:
            // OUTPUT TO BE HANDLED BY APPLICATION
            rsp_obj.code = rsp_code;
            rsp_obj.data = resultData;
        }
        return rsp_obj;
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (err) {
    rsp_obj.op_code = 500;
  }

  return rsp_obj;
};

export const api_assist_handler = async (func, data, method) => {
  const basePath = getBasePath();

  let rsp_code = "";
  let rsp_obj = {};

  var construct = {
    function: func,
    request: data,
  };

  try {
    await fetch(basePath + `aspsp/platform`, {
      method: method, // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      dataType: "text",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getTellToken(),
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(construct), // body data type must match "Content-Type" header
    })
      .then((response) => {
        rsp_code = response.status;
       
        return response.text();

      }) // parse JSON from request
      .then((resultData) => {
        switch (rsp_code) {
          case 404:
            rsp_obj.code = rsp_code;
            rsp_obj.data = {}
            break;
          default:
            // OUTPUT TO BE HANDLED BY APPLICATION
          
            rsp_obj.code = rsp_code;
            rsp_obj.data = resultData;
        }
        return rsp_obj;
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (err) {
    rsp_obj.op_code = 500;
  }

  return rsp_obj;
};

export const obie_api_handler = async (func, data, method) => {
  const basePath = getBasePath();

  let rsp_code = "";
  let rsp_obj = {};

  var construct = {
    function: func,
    request: data,
  };

  try {
    await fetch(basePath + func, {
      method: method, // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Content-Type": "application/json",
        //  'Authorization': 'Bearer '+getTellToken(),
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(construct), // body data type must match "Content-Type" header
    })
      .then((response) => {
        rsp_code = response.status;
        return response.json();
      }) // parse JSON from request
      .then((resultData) => {
        switch (rsp_code) {
          case 401:
            // UNAUTHENTICATED USER - ALWAYS LOGOUT

            //navigate("/login");
            break;
          default:
            // OUTPUT TO BE HANDLED BY APPLICATION
            rsp_obj.code = rsp_code;
            rsp_obj.data = resultData;
        }
        return rsp_obj;
      })
      .catch((error) => {
        console.log(error);
      });
  } catch (err) {
    rsp_obj.op_code = 500;
  }

  return rsp_obj;
};
